<template>
  <div class="password">
    <h1 style="text-align: center; padding-top: 15%; margin-bottom: 100px;">
      银关易数字科技服务平台{{ type == 'autho' ? '(数据看板)' : '(报表)' }}
    </h1>
    <div style="width: 400px; margin: 0 auto;">
      <el-input placeholder="请输入密码" @keyup.native="enter" v-model="as" show-password>
        <el-button slot="append" @click="login">确定</el-button>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'password',
  props: ['type'],
  data() {
    return {
      al: 'Union2022_Report2022',
      am: 'Union2022_DashBoard_Map2022',
      as: ''
    };
  },
  methods: {
    enter(e) {
      (e.keyCode == 13 || e.key == 'Enter') && this.login();
    },
    login() {
      if (this.type == 'login' && this.as === this.al) {
        this.$store.commit('SET_LOGIN', true);
        this.$setCookie('login', true);
      } else if (this.type == 'autho' && this.as === this.am) {
        this.$store.commit('SET_AUTHO', true);
        this.$setCookie('authority', true);
      } else if (this.as) {
        this.$message.error('密码错误');
      } else {
        this.$message.warning('请输入密码');
      }
    }
  }
};
</script>

<style scoped>
.password {
  height: 100%;
}
</style>
